import { render } from "./Loseblatt.vue?vue&type=template&id=46922bca"
import script from "./Loseblatt.vue?vue&type=script&lang=js"
export * from "./Loseblatt.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__